import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { MdMailOutline } from "react-icons/md";
import CardDetails from "./card_details";
import { useDispatch, useSelector } from "react-redux";
import { fetchDepartmentsData } from "../../redux/slicer/departmentsSlice";
import { useLocation } from "react-router-dom";

function CardDepartment() {
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [selectedStaffId, setSelectedStaffId] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const location = useLocation();

  // Extract the query parameter
  const searchParams = new URLSearchParams(location.search);
  const departmentId = searchParams.get("id");

  const dispatch = useDispatch();
  const {
    data: departmentsData,
    loading,
    error,
  } = useSelector((state) => state.departments.departments);

  useEffect(() => {
    if (!departmentsData.length) {
      dispatch(fetchDepartmentsData());
    }
  }, [dispatch, departmentsData.length]);

  // Filter the department based on the ID
  const department = departmentsData.find(
    (d) => d.department_id === parseInt(departmentId)
  );

  useEffect(() => {
    if (department && selectedStaffId) {
      const staff = department.staff_members.find(
        (s) => s.staff_id === selectedStaffId
      );
      setSelectedStaff(staff);
    } else {
      setSelectedStaff(null);
    }
  }, [department, selectedStaffId]);


  const openEditPopup = (staffId) => {
    setSelectedStaffId(staffId);
    setIsOpenEdit(true);
  };

  const closeEditPopup = () => {
    setSelectedStaffId(null);
    setIsOpenEdit(false);
  };

  const settings = {
    dots: true,
    infinite: department?.staff_members?.length > 3, // Disable infinite loop if less than 3 cards
    speed: 500,
    slidesToShow: Math.min(department?.staff_members?.length || 0, 3), // Show all cards if fewer than 3
    slidesToScroll: 1,
    prevArrow: (
      <div className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronLeft className="text-primary-color text-lg" />
      </div>
    ),
    nextArrow: (
      <div className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronRight className="text-primary-color text-lg" />
      </div>
    ),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: Math.min(department?.staff_members?.length || 0, 2) } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  if (loading) {
    return <div className="text-center text-primary-color">Loading...</div>;
  }

  if (error || !department) {
    return (
      <div className="text-center text-red-600">
        Error: {error || "Department not found."}
      </div>
    );
  }

  return (
    <div className="slider-container relative">
      <Slider {...settings}>
        {department.staff_members.map((staff) => (
          <div key={staff.staff_id} className="p-4">
            <div className="rounded shadow-lg bg-white max-w-[300px] mx-auto h-[450px] flex flex-col">
              <img
                className="rounded-t-lg w-full h-[250px] object-cover"
                src={staff.staff_image_url}
                alt={staff.staff_name}
              />
              <div className="px-6 py-6 flex flex-col justify-between flex-1">
                <div className="font-bold text-primary-color text-left font-inter">
                  {staff.staff_name}
                </div>
                <p className="text-black font-semibold text-base text-left font-inter">
                  {staff.staff_designation}
                </p>
                <p className="text-gray-500 text-sm text-left font-inter">
                  {department.department_name}
                </p>

                <div className="mt-auto pt-2 flex justify-between items-center font-inter">
                  <button
                    onClick={() =>
                      openEditPopup(staff.staff_id)
                    }
                    className="text-primary-color flex items-center"
                  >
                    Read More
                  </button>

                  <button
                    className="text-xl py-1 bg-primary-color text-white rounded-full w-8 h-8 flex items-center justify-center"
                    onClick={() => window.open(`mailto:${staff.staff_email}`)}
                  >
                    <MdMailOutline />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {isOpenEdit && selectedStaff && (
        <CardDetails staff={selectedStaff} onClose={closeEditPopup} />
      )}
    </div>
  );
}

export default CardDepartment;